import { Can } from 'providers/casl'

export const onHistoryAccess = (can: Can) => {
  can('access', 'HistoryPage')
}
